'use strict';

const Help = {
    'ejemplo': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Impedit, minima!'        
};

export default Help;


// WEBPACK FOOTER //
// ./src/app/common/lang/es/help.lang.js